// extracted by mini-css-extract-plugin
export default {"background":"THpL4ZzWoV4nhKMZ4MW5","instructions":"ljZqNpsu0RLnJbHnCTjF","slideIn":"PUDz42_UU5qDxhp5RxAc","close":"hNdDoiYCNBuuCz22MGIG"};